//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/Expression.js";
import "../Features/Features.SelectFeature.js";
import "../no/Expression.js";
import "../no/SelectObject.js";
let d=[[[0,"EyePoint",1,0],[0,"EyePointType",1,0],[1,"EyeRotationDown",0,"Expression",0],[1,"EyeRotationLeft",0,"Expression",0],[1,"EyeRotationRight",0,"Expression",0],[0,"EyeRotationType",1,0],[1,"EyeRotationUp",0,"Expression",0],[1,"Eyellipse",0,"Features.SelectFeature",0],[1,"HeadRotationLeft",0,"Expression",0],[1,"HeadRotationRight",0,"Expression",0],[0,"HeadTurnType",1,0],[0,"Standard",1,0],[0,"UseHeadTurnToggle",1,0],[0,"UserDefinedPoint",1,"Point",0]],[],[]];
SPLM.Features.DirectVisionBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.DirectVisionBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.DirectVisionBuilder.VisionType = Object.freeze({
    "Monocular" : "Monocular", "Binocular" : "Binocular", "UserDefined" : "UserDefined"});

SPLM.Features.DirectVisionBuilder.EyeRotationTypes = Object.freeze({
    "Easy" : "Easy", "Maximum" : "Maximum", "UserDefined" : "UserDefined"});

SPLM.Features.DirectVisionBuilder.HeadTurnTypes = Object.freeze({
    "Easy" : "Easy", "Maximum" : "Maximum", "UserDefined" : "UserDefined"});

export default SPLM;